const linkResolver = (doc) => {
  const subDirectory = doc.uid.replace('_', '/');
  const category = doc.tags[0] ? `/${doc.tags[0]}/` : '/';
  return category + subDirectory;
};
export default linkResolver;
